export default window.Core.getHashParameter;
